/** `/card/:token` — the public PointFive Score card as an external surface (SDD §7.4 "Public score card").
 *  Renders the reference's "Your Score, as investors see it" composition verbatim (tools/dc-port fragment `PublicCard`)
 *  on the brand's external ground. Phase 1: token is not validated (simulated); revoked-token state lands with the public family. */
import { useParams } from 'react-router';
import { PublicCardView } from '@/screens/generated/PublicCard.fragment';
import { useViewModel } from '@/app/useViewModel';
import { SimulatedBadge } from '@pointfive/ui';

export function PublicCardPage() {
  const { token } = useParams();
  const m = useViewModel({ showFxTicker: false, accountCount: 5, avatarSrc: '' });
  return (
    <div
      data-page="public-card"
      data-theme="dark"
      style={{
        minHeight: '100vh',
        background: 'var(--pub-ground)',
        color: 'var(--pub-ink)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 16px',
        fontSize: '13px',
      }}
    >
      <div
        style={{ width: '100%', maxWidth: '880px', display: 'flex', flexDirection: 'column', gap: '14px' }}
      >
        <PublicCardView m={m} />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px',
            fontSize: '10px',
            color: 'var(--pub-dim)',
          }}
        >
          <span>Verified figures only · card {token ?? ''} · views are counted</span>
          <SimulatedBadge what="public card token" />
        </div>
      </div>
    </div>
  );
}
